import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from "axios";
import getBaseUrl from "../utils/apiUrl";
import token from "../utils/tokenAuthorization";
import {deleteKaryawan, detailKaryawan, storeKaryawan} from "./karyawanSlice";
import formatDate from "../utils/formatDate";

const validateForm = (state) => {
    const errors = {
        nama: '',
        niy: '',
        email: '',
        password: '',
        noHp: '',
        alamat: '',
    };


    if (state?.nama?.trim() === '') {
        errors.nama = 'Isi nama';
    }

    if (state.niy?.trim() === '' || state.niy?.length < 8) {
        errors.niy = 'Isi NIY minimal 8 digit.';
    }

    if (state.password?.trim() === '' || state.password?.length <= 6) {
        errors.password = 'Isi password minimal 6 karakter';
    }



    return errors;
};

const initialState = {
    listSiswa: [],
    listKelas: [],
    currentPage: 1,
    keterangan: null,
    urutan: {
        column: 'nama',
        order: 'asc'
    },
    search: '',

    nama: '',
    niy: '',
    password: '',
    kelas:'',

    errors: {
        nama: '',
        email: '',
        password: '',
        kelas: '',
    },
    listJadwal: [
        {
            hari: 'senin',
            jam_masuk: '',
            jam_pulang: ''
        },
        {
            hari: 'selasa',
            jam_masuk: '',
            jam_pulang: ''
        },
        {
            hari: 'rabu',
            jam_masuk: '',
            jam_pulang: ''
        },
        {
            hari: 'kamis',
            jam_masuk: '',
            jam_pulang: ''
        },
        {
            hari: 'jumat',
            jam_masuk: '',
            jam_pulang: ''
        },
        {
            hari: 'sabtu',
            jam_masuk: '',
            jam_pulang: ''
        },
        {
            hari: 'minggu',
            jam_masuk: '',
            jam_pulang: ''
        }
    ],

    startText: 'Tanggal mulai',
    endText: 'Tanggal berakhir',
    startTime: formatDate(new Date()),
    endTime: null,
    isFormValid: false,
    isFormErrorShown: false,
    isFormEditted: false,

    isInitialGet: false,
    statusResApi: '',
    messageResApi: '',
    isDisplayMessage: false,

    isLoading: true,
    isLoadingList: true,
    loadingStore:false,
    loadingEdit:false
};

export const listGetSiswa = createAsyncThunk("siswa/listGetSiswa", async ({ search }, { rejectWithValue }) => {
    try {

        const response = await axios.get(
            getBaseUrl + '/api/list/classes',
            {
                headers: {
                    Authorization: `Bearer ${token()}`,
                },
                params: {
                    search
                },
                timeout: 20000
            }
        )
        return response.data
    } catch (error) {
        if (axios.isCancel(error)) {
            throw new Error('Request canceled');
        }

        if (error.code === 'ECONNABORTED') {
            return rejectWithValue('Request timeout');
        } else if (error.response.data.admin === false) {
            return rejectWithValue('Permission denied');
        }

        return rejectWithValue(error.message)
    }
})

export const getSiswa = createAsyncThunk("siswa/getSiswa", async ({start_time,end_time, kelas,search }, { rejectWithValue }) => {
    try {

        const response = await axios.get(
            getBaseUrl + '/api/students',
            {
                headers: {
                    Authorization: `Bearer ${token()}`,
                },
                params: {
                    start_time,
                    end_time,
                    kelas,
                    search
                },
                timeout: 20000
            }
        )
        return response.data
    } catch (error) {
        if (axios.isCancel(error)) {
            throw new Error('Request canceled');
        }

        if (error.code === 'ECONNABORTED') {
            return rejectWithValue('Request timeout');
        } else if (error.response.data.admin === false) {
            return rejectWithValue('Permission denied');
        }

        return rejectWithValue(error.message)
    }
})


export const storeSiswa = createAsyncThunk("siswa/storeSiswa", async ({

                                                                                   nama, niy, password, class_id
                                                                               }, { rejectWithValue }) => {
    const formData = new FormData();
    formData.append('nama', nama);
    formData.append('niy', niy);
    formData.append('password', password);
    formData.append('class_id', parseInt(class_id));


    try {
        const response = await axios.post(
            getBaseUrl + `/api/students`,
            formData,
            {
                headers: {
                    Authorization: `Bearer ${token()}`,
                },
                timeout: 20000
            },
        )
        return response.data
    } catch (error) {
        if (axios.isCancel(error)) {
            throw new Error('Request canceled');
        }

        if (error.code === 'ECONNABORTED') {
            return rejectWithValue('Request timeout');
        } else if (error.response.data.admin === false) {
            return rejectWithValue('Permission denied');
        }

        return rejectWithValue(error.message);
    }

});


export const updateSiswa = createAsyncThunk("siswa/editSiswa", async ({
                                                                                   id, nama, password, class_id
                                                                               }, { rejectWithValue }) => {

    const formData = new FormData();
    formData.append('nama', nama);
    formData.append('password', password);
    formData.append('class_id', class_id);

    try {
        const response = await axios.put(
            getBaseUrl + `/api/students/${id}`,
            {
                "nama": nama,
                "password": password,
                "class_id": class_id,
            },
            {
                headers: {
                    Authorization: `Bearer ${token()}`,
                },
                timeout: 20000
            }
        )
        return response.data
    } catch (error) {
        if (axios.isCancel(error)) {
            throw new Error('Request canceled');
        }

        if (error.code === 'ECONNABORTED') {
            return rejectWithValue('Request timeout');
        } else if (error.response.data.admin === false) {
            return rejectWithValue('Permission denied');
        }

        return rejectWithValue(error.message);
    }

});



export const updateSiswaAccess = createAsyncThunk("siswa/editSiswaAccess", async ({
                                                                                id, access
                                                                            }, { rejectWithValue }) => {



    try {
        const response = await axios.put(
            getBaseUrl + `/api/students-access/${id}`,
            {
                "access": access,
            },
            {
                headers: {
                    Authorization: `Bearer ${token()}`,
                },
                timeout: 20000
            }
        )
        return response.data
    } catch (error) {
        if (axios.isCancel(error)) {
            throw new Error('Request canceled');
        }

        if (error.code === 'ECONNABORTED') {
            return rejectWithValue('Request timeout');
        } else if (error.response.data.admin === false) {
            return rejectWithValue('Permission denied');
        }

        return rejectWithValue(error.message);
    }

});


export const detailSiswa = createAsyncThunk("siswa/detailSiswa", async (id, { rejectWithValue }) => {
    try {
        const response = await axios.get(
            getBaseUrl + `/api/students/${id}`,
            {
                headers: {
                    Authorization: `Bearer ${token()}`,
                },
                timeout: 20000
            }
        )
        return response.data
    } catch (error) {
        if (axios.isCancel(error)) {
            throw new Error('Request canceled');
        }

        if (error.code === 'ECONNABORTED') {
            return rejectWithValue('Request timeout');
        } else if (error.response.data.admin === false) {
            return rejectWithValue('Permission denied');
        }

        return rejectWithValue(error.message)
    }
});

export const deleteSiswa = createAsyncThunk("siswa/deleteSiswa", async (id, { rejectWithValue }) => {
    try {
        const response = await axios.delete(
            getBaseUrl + `/api/students/${id}`,
            {
                headers: {
                    Authorization: `Bearer ${token()}`,
                },
                timeout: 20000
            }
        )

        return response.data
    } catch (error) {
        if (axios.isCancel(error)) {
            throw new Error('Request canceled');
        }

        if (error.code === 'ECONNABORTED') {
            return rejectWithValue('Request timeout');
        } else if (error.response.data.admin === false) {
            return rejectWithValue('Permission denied');
        }

        return rejectWithValue(error.message)
    }
});


export const importSiswa = createAsyncThunk("siswa/import", async (file, { rejectWithValue }) => {
    const formData = new FormData()
    formData.append('file', file)

    try {
        const response = await axios.post(
            getBaseUrl + `/api/students-import`,
            formData,
            {
                headers: {
                    Authorization: `Bearer ${token()}`,
                },
                timeout: 20000
            }
        )
        return response.data
    } catch (error) {
        if (axios.isCancel(error)) {
            throw new Error('Request canceled');
        }

        if (error.code === 'ECONNABORTED') {
            return rejectWithValue('Request timeout');
        } else if (error.response.data.admin === false) {
            return rejectWithValue('Permission denied');
        }

        return rejectWithValue(error.message)
    }
})


const siswaSlice = createSlice({
    name: 'siswa',
    initialState,
    reducers: {
        updateFieldValue: (state, action) => {
            const { field, value } = action.payload;
            if (field === 'listJadwal') {
                state.listJadwal = value;
            } else {
                console.log(action.payload)
                state[field] = value;
            }
        },
        updateFieldError: (state, action) => {
            const { field, error } = action.payload;
            state.errors[field] = error;
        },
        updateStateSiswa: (state, action) => {

            const { name, value } = action.payload
            state[name] = value
        },
        resetForm: () => initialState,
        resetField: (state, action) => {
            const field = action.payload;
            state[field] = '';
            state.errors[field] = 'Isi nama';
        },
        setImgUpload: (state, action) => {
            return action.payload
        },
        updateClassSiswa: (state, action) => {
            const { category, id } = action.payload;
            console.log(action.payload)
            state.kelas = action.payload
            // const isIdAlreadyAdded = state.listKtgkaryawan.some((item) => item.id === id);
            // if (!isIdAlreadyAdded) {
            //     state.listKtgkaryawan.push({ id, kategori });
            // }
        },
        deleteKelas: (state, action) => {
            state.kelas = null
        },
        resetListSiswa: (state) => {
            state.listSiswa = []
        },
        resetTable: (state) => {
            state.listSiswa = []
            state.isLoading = true
        },
        showFormError: (state, action) => {


            if (state.nama.trim() === '' && (action.payload === undefined || action.payload === 'nama')) {
                state.errors.nama = 'Isi nama';
            }

            if ((state.niy.trim() === '' || state.niy.length < 8) && (action.payload === undefined || action.payload === 'niy')) {
                state.errors.niy = 'Isi NIY minimal 8 digit.';
            }

            const validatePassword = (password) => {
                const uppercaseRegex = /[A-Z]/;
                const numberRegex = /[0-9]/;
                const symbolRegex = /[!@#$%^&*()_+{}\[\]:;<>,.?~\-\\/]/;

                return (
                    uppercaseRegex.test(password) &&
                    numberRegex.test(password) &&
                    symbolRegex.test(password)
                );
            };

            if ((state.password.trim() === '' || state.password.length < 6) && (action.payload === undefined || action.payload === 'password')) {
                state.errors.password = 'Isi password minimal 6 karakter';
            } else if (!validatePassword(state.password) && (action.payload === undefined || action.payload === 'password')) {
                state.errors.password = 'Isi passwoed minimal ada huruf besar, angka dan simbol';
            }


            if (!state.listJadwal.some((jadwal) => jadwal.jam_masuk !== '' && jadwal.jam_pulang !== '') && (action.payload === undefined || action.payload === 'jadwal')) {
                state.errors.jadwal = 'Isi Jadwal siswa';
            }

            if (!state.isFileSend && (action.payload === undefined || action.payload === 'isFileSend')) {
                state.errors.isFileSend = 'Isi Foto Siswa';
            }

            state.isFormErrorShown = true;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getSiswa.pending, (state) => {
                console.log("halo mo")
                state.isLoading = true;
            })
            .addCase(getSiswa.fulfilled, (state, action) => {
                console.log(action.payload);
                state.isLoading = false;
                state.listSiswa = action.payload.data;
                state.isInitialGet = true
            })
            .addCase(getSiswa.rejected, (state, action) => {
                state.isLoading = false;
                state.statusResApi = action.error.message
                state.messageResApi = action.payload
                state.isDisplayMessage = true
            })

            .addCase(listGetSiswa.pending, (state) => {
                state.isLoadingList = true;
            })
            .addCase(listGetSiswa.fulfilled, (state, action) => {
                console.log(action.payload);
                state.isLoadingList = false;
                state.listKelas = action.payload.data;
                state.isInitialGet = true
            })
            .addCase(listGetSiswa.rejected, (state, action) => {
                state.isLoadingList = false;
                state.statusResApi = action.error.message
                state.messageResApi = action.payload
                state.isDisplayMessage = true
            })


            .addCase(storeSiswa.pending, (state) => {
                state.loadingStore = true;
            })
            .addCase(storeSiswa.fulfilled, (state) => {
                state.loadingStore = false;
                state.statusResApi = 'success'
                state.messageResApi = 'Siswa berhasil ditambahkan'
                state.isDisplayMessage = true
            })
            .addCase(storeSiswa.rejected, (state, action) => {
                state.loadingStore = false;
                state.statusResApi = action.error.message
                state.messageResApi = action.payload
                state.isDisplayMessage = true
            })

            .addCase(detailSiswa.pending, (state) => {
                state.isLoading = true;
                state.loadingEdit = true;
            })
            .addCase(detailSiswa.fulfilled, (state, action) => {

                console.log(action.payload)
                state.isLoading = false;
                state.loadingEdit = false;
                const initialData = action.payload.user;
                state.nama = initialData.nama;
                state.niy = initialData.niy;
                state.password = 'password';
                state.kelas = initialData.classes;

                state.errors = validateForm(state);
            })
            .addCase(detailSiswa.rejected, (state, action) => {
                state.isLoading = false;
                state.loadingEdit = false;
                state.statusResApi = action.error.message
                state.messageResApi = action.payload
                state.isDisplayMessage = true
            })


            .addCase(deleteSiswa.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(deleteSiswa.fulfilled, (state) => {
                state.isLoading = false;
                state.statusResApi = 'success'
                state.messageResApi = 'Siswa berhasil dihapus'
                state.isDisplayMessage = true
            })
            .addCase(deleteSiswa.rejected, (state, action) => {
                state.isLoading = false;
                state.statusResApi = action.error.message
                state.messageResApi = action.payload
                state.isDisplayMessage = true
            })

            .addCase(importSiswa.pending, (state) => {
                state.loading = true
            })
            .addCase(importSiswa.fulfilled, (state) => {
                state.loading = false
                state.statusResApi = 'success'
                state.messageResApi = 'Siswa berhasil di import'
                state.isDisplayMessage = true
            })
            .addCase(importSiswa.rejected, (state, action) => {
                state.loading = false
                state.statusResApi = action.error.message
                state.messageResApi = action.payload
                state.isDisplayMessage = true
            })

    }
});

export const {
    updateFieldValue, updateFieldError, resetForm, updateClassSiswa,setFormLoading, resetField, resetTable,
    setImgUpload, deleteKelas, updateStateSiswa, resetListSiswa, showFormError
} = siswaSlice.actions;
export default siswaSlice.reducer;